export function HarnessSelector({ harnessId, onChange }) {
  return (
    <label className="block text-sm font-semibold text-body-500">
      Harness
      <select
        className="mt-2 w-full rounded-md border border-mystic-500 px-3 py-2 text-sm font-normal text-body-500 outline-none transition focus:border-dodger-blue-500 focus:ring-2 focus:ring-dodger-blue-100"
        onChange={(event) => onChange(event.target.value)}
        value={harnessId}
      >
        <option value="">Select a harness</option>
        <option value="example">Example</option>
      </select>
    </label>
  );
}
